import pic81 from './assets/images/81.jpg';
import pic82 from './assets/images/82.jpg';
import pic83 from './assets/images/83.jpg';
import pic85 from './assets/images/85.jpg';

import svg11 from './assets/svg/11.svg';
import svg22 from './assets/svg/22.svg';
import svg43 from './assets/svg/43.svg';
import svg64 from './assets/svg/64.svg';

const Eight = () => (
	  <section style={{paddingTop: "1em"}}>
		<div className="section-num" style={{top: 0}}>3</div>
		<p><img src={pic81} alt="" /></p>
		<div className="wrapper">
			<h2>Jak poznáš<br />stáří stromu?</h2>
			<p className="like-h3">Stromy jsou jako přírodní knihovny. Podle počtu letokruhů zjistíš jejich přesný věk – co kruh, to jeden rok. Velká vzdálenost mezi letokruhy značí dostatek vláhy v daném roce.</p>
			<p className="txt-right" style={{marginBottom: ".75em"}}>
				<span className="relative inline-block" style={{maxWidth: "15em"}}>Světlé dřevo naznačuje, že strom prošel velkým stresem, např. masivním napadnutím škůdci nebo přírodní katastrofou.
					<img src={svg11} className="pointer" style={{top: "105%", right: "50%", maxWidth: "20%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic82} alt="" /></p>
		<div className="wrapper">
			<p><b className="tip">Tip pro tebe:</b> Jsi u broukoviště, které vzniklo z&nbsp;kmenů nemocných a poškozených stromů. Pokáceny byly v lesoparku v roce 2024. Spočítej&nbsp;jim letokruhy a zjisti, jak dlouho tu rostly. Jejich mrtvé dřevo bude brzy plné života – brouků, samotářských včel, ještěrek a hub.</p>
			<h2>Nejstarší stromy na&nbsp;zemi</h2>
			<p className="like-h3">V Česku roste okolo 25 stromů, kterým je víc jak 700 let. Nejstaršímu českému staříkovi, Vilémovickému tisu červenému u Ledče nad Sázavou, je&nbsp;přibližně 1500 let.</p>
			<p>
				<span className="relative inline-block" style={{maxWidth: "15em"}}>„Metuzalém“ je jedinec borovice dlouhověké, která roste v Kalifornii v severní Americe. Jeho vyklíčení ze semínka se odhaduje na&nbsp;rok 2833 před naším letopočtem. 
					<img src={svg43} className="pointer" style={{top: "105%", left: "80%", maxWidth: "10%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic83} alt="" /></p>
		<div className="wrapper">
			<p className="txt-right" style={{marginTop: "-.75em"}}>
				<span className="relative inline-block" style={{maxWidth: "17.25em"}}>V Guinessově knize rekordů je zapsán jako nejstarší žijící strom na světě. Extrémně pomalým růstem se přizpůsobil drsným horským podmínkám, suchu, chladu a silnému větru.
					<img src={svg64} className="pointer" style={{bottom: "100%", right: "5%", maxWidth: "30%"}} alt="" />
				</span>
			</p>
			<h2>Superschopnosti stromů</h2>
			<p className="like-h3">Pokácíš strom a on znova vyroste z&nbsp;pařezu. Zázrak? Ne! Je to přirozená superschopnost lípy, dubu nebo třeba javoru. Nově vyrostlý strom je geneticky na chlup stejný jako jeho „matka“, která je tak vlastně nesmrtelná.</p>
		</div>
		<div className="wrapper">
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Stromy jako topol, akát nebo pajasan se umí klonovat ze svých kořenů. V americkém státě Utah roste jedinečná klonová kolonie topolu osikovitého „Pando“.
					<img src={svg11} className="pointer" style={{top: "100%", right: "40%", maxWidth: "20%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic85} alt="" /></p>
		<div className="wrapper">
			<p>
				<span className="relative inline-block" style={{maxWidth: "15.5em"}}>Její kořenový systém je starý zhruba 80 000 let a vyrůstá z něj asi 40 000 geneticky stejných kmenů. Když kmeny uhynou, stromový organismus je nahradí novými.
					<img src={svg22} className="pointer" style={{bottom: "100%", left: "80%", maxWidth: "15%"}} alt="" />
				</span>
			</p>
		</div>
	</section>
);

export default Eight;
